export const BREAKPOINT_MIN_WIDTH = Object.freeze({
  xxl: 1400,
  xl: 1200,
  lg: 992,
  md: 768,
  sm: 576,
  xs: 0,
});

export const BREAKPOINT_MAX_WIDTH = Object.freeze({
  xl: 1199,
  lg: 992,
  md: 991,
  sm: 767,
  xs: 575,
});

export const BREAKPOINT_SIZES = Object.freeze({
  xxl: 'xxl',
  xl: 'xl',
  lg: 'lg',
  md: 'md',
  sm: 'sm',
  xs: 'xz',
});
